<ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data | async" aria-label="Organization Chiefs Orders"></ag-grid-angular>